import React from 'react'

import strings from '../../../strings'
import { Text, Grid, GridRow } from '@mytours/components'

import './styles/loader.less'

const Loader: React.FC = () => (
	<Grid className="loader-container">
		<GridRow className="spinner-row">
			<i className="fal fa-spinner fa-spin" />
		</GridRow>
		<GridRow>
			<Text variant="inherit" aria-live="assertive">
				{strings.loading}
			</Text>
		</GridRow>
	</Grid>
)

export default Loader
